// extracted by mini-css-extract-plugin
export default {"steps_container":"ReferralCabinetInfoSection_steps_container__3e1SV","steps_container_mobile":"ReferralCabinetInfoSection_steps_container_mobile__+0Vqn"};